import { render, staticRenderFns } from "./OsInputCheckbox.vue?vue&type=template&id=40d40978&scoped=true"
import script from "./OsInputCheckbox.vue?vue&type=script&lang=ts"
export * from "./OsInputCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d40978",
  null
  
)

export default component.exports